import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Cash.svg",
  "use": "Cash.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Cash.svg\"><path d=\"M56.0105,47.0209h-48a2,2,0,0,1-2-2v-26a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2v26A2,2,0,0,1,56.0105,47.0209Zm-2-20a6,6,0,0,1-6-6h-32a6,6,0,0,1-6,6v11a5.9966,5.9966,0,0,1,5.91,5h32.18a5.9964,5.9964,0,0,1,5.91-5Zm-22,13c-3.6563,0-6-3.125-6-8s2.3437-8,6-8,6,3.125,6,8S35.6668,40.0208,32.0105,40.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol